// @ts-nocheck

import React, { FunctionComponent, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { campaignsList } from 'Router/routes'
import { setTrackToInitialState } from 'Redux/actions/trackActions'
import {
  addNewCampaign,
  setTiktokValueToWebhook,
} from 'Redux/actions/campaignActions'
import { setIsFirstCampaign } from 'Redux/actions/auth'
import {
  getUserSelector,
  getIsFirstCampaign,
  getUserId,
} from 'Redux/selectors/auth'
import { getAmountOfCampaigns } from 'Redux/selectors/campaigns'
import {
  createCampaignEvent,
  createCampaignStartEvent,
  locationEvent,
  pageInfo,
  pageViewEvent,
  createdCampaignEvent,
} from 'Helpers/tagManager'

import { changeSidebarVisibility } from 'Redux/actions/sidebarActions'
import { CreateCampaignLayout } from 'Containers/CreateCampaignWithoutSignup/components/CreateCampaignLayout'
import { getCollapse } from 'Redux/selectors/sidebar'
import { dimensions } from 'Styled/variables'
import { Track, CampaignPlatformTypeEnum } from '../../Types'
import './components/style.scss'

const CreateCampaignForm: FunctionComponent = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const spotifyTrack: Track = useSelector(
    (state: RootStateOrAny) => state.spotifyTrack.track
  )

  const collapse: boolean = useSelector(getCollapse)

  const spotifyTracks: Array<Track> = useSelector(
    (state: RootStateOrAny) => state.spotifyTracks.tracks
  )

  const accessToken: string = useSelector(
    (state: RootStateOrAny) => state.spotifyToken.accessToken
  )
  const isFirstCampaign = useSelector(getIsFirstCampaign)
  const userID = useSelector(getUserId)
  const user = useSelector(getUserSelector)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const campaignNumber = amountOfCampaigns + 1

  const [isChangedTrack, setIsChangedTrack] = useState(false)

  const [isCheckedSpotify, setCheckedSpotify] = useState(true)
  const [isCheckedTikTok, setCheckedTikTok] = useState(false)

  useEffect(() => {
    pageViewEvent(user, pageInfo.createCampaign)
    createCampaignStartEvent(user, campaignNumber)
    locationEvent()
  }, [])

  useEffect(() => {
    dispatch(setTrackToInitialState())
    !collapse &&
      window.innerWidth >= dimensions.mobileBorder &&
      dispatch(changeSidebarVisibility())
  }, [])

  const handleSubmit = () => {
    const trackName = spotifyTrack?.name
    const artist = spotifyTrack?.artists[0].name
    const trackURL = spotifyTrack?.href
    const trackImage = spotifyTrack?.album?.images[1]?.url
    const artistUrl = spotifyTrack?.artists[0].external_urls.spotify
    const spotifyTrackID = spotifyTrack?.id
    const artistSpotifyID = spotifyTrack?.artists[0].id
    const user = JSON.parse(localStorage.getItem('user'))
    const track_length = spotifyTrack?.duration_ms
    user && (user.is_first_campaign = false)
    const url = window.location.href

    // fix in the future
    const genre_ids = []
    const language_ids = [3]
    const mood_ids = []

    isCheckedTikTok &&
      dispatch(
        setTiktokValueToWebhook(user.first_name, user.last_name, user.email)
      )

    dispatch(setIsFirstCampaign(false))
    localStorage.setItem('user', JSON.stringify(user))
    dispatch(
      addNewCampaign(
        trackName,
        artist,
        trackURL,
        trackImage,
        genre_ids,
        artistUrl,
        spotifyTrackID,
        artistSpotifyID,
        track_length,
        language_ids,
        mood_ids,
        url,
        (error, response) => {
          if (!error) {
            createCampaignEvent(user, response.id)
            createdCampaignEvent(
              response.type,
              CampaignPlatformTypeEnum.SPOTIFY,
              response.id,
              userID,
              campaignNumber || 1,
              response.is_feed
            )
          }
          //  eslint-disable-next-line @typescript-eslint/no-explicit-any
          localStorage.setItem('isTrackSubmittedModal', true as any)
          localStorage.setItem('campaignType', response.type)
          history.push(`${campaignsList}`)
        }
      )
    )
  }

  return (
    <CreateCampaignLayout
      history={history}
      isChangedTrack={isChangedTrack}
      handleSubmit={handleSubmit}
      isCheckedSpotify={isCheckedSpotify}
      setCheckedSpotify={setCheckedSpotify}
      accessToken={accessToken}
      isCheckedTikTok={isCheckedTikTok}
      setCheckedTiktok={setCheckedTikTok}
      setIsChangedTrack={setIsChangedTrack}
      spotifyTrack={spotifyTrack}
      spotifyTracks={spotifyTracks}
    />
  )
}

export default CreateCampaignForm
